export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Regular.5708f5b4.otf";